//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import TableServer from '../../../../components/Table/Table.vue'
import TableCellObject from '../../../../components/Table/TableCellObject.vue'
import StockConfigurationDepartmentSelector from './StockConfigurationDepartmentSelector.vue'
import StockControlledToolDepartmentsDropdown from './StockControlledToolDepartmentsDropdown.vue'
import StockControlledToolDepartments from './StockControlledToolDepartments.vue'
import StockToolPartyInfo from '../../../../forms/StockTools/StockToolPartyInfo.vue'
import { getStockControlToolRecordColumns, showStockControlDialog } from './StockControl.js'
import { EventBus } from '../../../../EventBus/EventBus.js'
import { axiosPost } from '../../../../axios/axios.js'

export default {
  name: 'StocksControlledTools',
  components: {
    TableServer,
    TableCellObject,
    StockControlledToolDepartmentsDropdown,
    StockControlledToolDepartments,
    StockConfigurationDepartmentSelector
  },
  props: {
    stockId: {
      type: Number,
      default: null
    },
    formId: {
      type: String,
      default: null
    }
  },
  data: function () {
    const vm = this

    return {
      departmentSelectorConfig: {
        loading: false,
        departmentId: null,
        department: null,
        departments: [],
        get hasChanges () {
          return vm.hasChanges
        }
      },

      exportOptions: [],

      controlListType: null,
      controlListTypeOptions: [
        { value: 'selectedDepartment', label: 'Контролируемые данным отделом на данном складе' },
        { value: 'anyDepartment', label: 'Контролируемые всеми отделами на данном складе' },
        { value: 'allInStock', label: 'Все позиции на данном складе' },
        { value: 'all', label: 'Все позиции на всех складах' }
      ],

      baseUrl: '/service/delta/stock/control/tools',
      additionalUrlParams: this.getAdditionalUrlParams(),
      updateEvent: 'update-controlledTool',
      filterType: 'controlledTool',
      autoUpdateTimeout: 300000,
      itemMapper: item => {
        let controlledBySelectedDepartment = !!item.controlledBySelectedDepartment
        item.controlledBySelectedDepartmentInitial = !!item.controlledBySelectedDepartment

        if (vm.changedItemsIds.has(item.id)) {
          const selectedItem = vm.changedItems.find(element => element.id == item.id)
          controlledBySelectedDepartment = !!selectedItem.controlledBySelectedDepartment
        }
        item.controlledBySelectedDepartment = controlledBySelectedDepartment

        Object.defineProperty(item, 'changed', {
          get: function () {
            return this.controlledBySelectedDepartment != this.controlledBySelectedDepartmentInitial
          }
        })
        return item
      },

      checkProperty: 'controlledBySelectedDepartment',
      allItemsChecked: false,
      changedItems: [],
      changedItemsIds: new Set(),

      columns: this.getColumns(),
      loading: false,
      tableLoading: false
    }
  },
  computed: {
    hasEditAccess: function () {
      const department = this.departmentSelectorConfig.department
      return !!(department && department.editAccess)
      // return this.$d_hasOperation('stockAccessoryControl')
    },
    hasControlPerformAccess: function () {
      return this.hasEditAccess
    },
    hasChanges: function () {
      return !!(this.changedItems && this.changedItems.length)
    },
    loadingCommon: function () {
      return this.loading || this.tableLoading
    },
    initialized: function () {
      return this.additionalUrlParams.depId != null
    }
  },
  watch: {
    'departmentSelectorConfig.departmentId': function (id, oldId) {
      if (oldId != null) {
        this.clearChanges(true)

        this.$nextTick(() => {
          EventBus.$emit(this.updateEvent, { target: this })
        })
      }
      this.updateAdditionalUrlParams()
    },
    loadingCommon: function (value) {
      this.$emit('loading-change', value)
    }
  },
  mounted: function () {
    EventBus.$on(this.updateEvent, this.onUpdateEvent)
  },
  beforeDestroy: function () {
    EventBus.$off(this.updateEvent, this.onUpdateEvent)
  },
  methods: {
    /**
     * Может вызываться извне
     */
    onUpdate: function () {
      this.clearChanges(false)

      const tableComponent = this.$refs.table
      if (tableComponent) {
        tableComponent.onUpdate()
      }
    },
    onTableLoadingChange: function (value) {
      this.tableLoading = value
    },
    updateTableOptions () {
      let exportOptions
      if (this.controlListType == null || this.controlListType === 'all') {
        exportOptions = []
      } else {
        const vm = this
        exportOptions = [
          {
            label: 'Выгрузить в Excel',
            includeFilter: true,
            props: {
              stockId: this.stockId,
              get departmentId () {
                return vm.departmentSelectorConfig.departmentId || null
              },
              get controlListType () {
                return vm.controlListType || null
              }
            }
          }
        ]
      }
      this.exportOptions = exportOptions

      this.$nextTick(() => {
        const tableComponent = this.$refs.table
        if (tableComponent) {
          tableComponent.updateDownloadTableAccess()
        }
      })
    },

    getColumns: function () {
      const columns = getStockControlToolRecordColumns() // this.editControlSettingsMode ? 'edit' : 'view'
      return this.prepareColumns(columns)
    },
    prepareColumns: function (columns) {
      for (const column of columns) {
        if (!column.field) {
          column.field = column.name
        }
        if (!column.align) {
          column.align = 'left'
        }
      }
      return columns
    },

    onChangeControlListType: function (value) {
      this.clearChanges(true)
      this.setControlListType(value)
    },
    setControlListType: function (value) {
      const oldValue = this.controlListType
      if (oldValue !== value) {
        const initial = oldValue == null
        this.controlListType = value
        console.log('setControlListType', oldValue, value)

        if (!initial) { // иначе запустится повторный вызов обновления таблицы
          this.updateAdditionalUrlParams()
        }
      }

      this.updateTableOptions()
    },
    updateAdditionalUrlParams: function () {
      const additionalUrlParams = this.getAdditionalUrlParams()
      if (JSON.stringify(additionalUrlParams) !== JSON.stringify(this.additionalUrlParams)) {
        this.additionalUrlParams = additionalUrlParams
      }
    },
    getAdditionalUrlParams: function () {
      const params = {}
      if (this.stockId) {
        params.stockId = this.stockId
      }
      if (this.controlListType) {
        params.controlListType = this.controlListType
      }
      // if (this.hasEditAccess && this.departmentSelectorConfig.departmentId != null) {
      if (this.departmentSelectorConfig && this.departmentSelectorConfig.departmentId != null) {
        params.depId = this.departmentSelectorConfig.departmentId
      }
      return params
    },

    onTableItemsUpdated: function (event) {
      this.updateAllItemsChecked(event.data)

      const additionalData = event.additionalData
      if (additionalData) {
        if (additionalData.controlListType && additionalData.controlListType != this.controlListType) {
          this.setControlListType(additionalData.controlListType)
        }
        if (additionalData.filterUpdated) {
          EventBus.$emit('update-server-filter', {
            type: this.filterType
          })
        }
      }
    },
    onUpdateEvent: function (event) {
      if (event && event.target != this) {
        this.clearChanges(true)
      }
    },
    onClickRow: function (col, row) {
      if (col.name === 'isParty' && row.isParty) {
        const dialog = this.$d.dialog(this).show({
          headerLabel: `${row.toolName}`,
          contentComponent: StockToolPartyInfo,
          maximized: true,
          contentProps: {
            toolKey: row.toolKey,
            stockId: row.stock.id,
            unit: row.unit,
            complex: true
          }
        })
      }
    },
    onCheckAllItems: function (value) {
      this.allItemsChecked = value

      const items = this.$refs.table.data
      for (const item of items) {
        this.onCheckItem(item, value, true)
      }
    },
    updateAllItemsChecked: function (items) {
      if (items == null) {
        items = this.$refs.table.data
      }

      let allItemsChecked = false
      if (items && items.length) {
        allItemsChecked = true
        for (const item of items) {
          if (!item[this.checkProperty]) {
            allItemsChecked = false
            break
          }
        }
      }

      this.allItemsChecked = allItemsChecked
    },
    onCheckItem: function (item, isChecked, ignoreAll) {
      // item.isChecked = isChecked
      item[this.checkProperty] = isChecked // item.controlledBySelectedDepartment = isChecked

      if (this.changedItemsIds.has(item.id)) {
        if (!item.changed) {
          this.changedItemsIds.delete(item.id)
          const selectedIndex = this.changedItems.findIndex(element => element.id == item.id)
          if (selectedIndex !== -1) {
            this.changedItems.splice(selectedIndex, 1)
          }
        }
      } else {
        if (item.changed) {
          this.changedItemsIds.add(item.id)
          this.changedItems.push(item)
        }
      }

      if (!ignoreAll) {
        this.updateAllItemsChecked()
      }
    },
    onClearChanges: function () {
      this.clearChanges(true)
    },
    clearChanges: function (notify) {
      if (this.changedItemsIds.size) {
        const items = this.$refs.table.data
        items.forEach(item => {
          if (item.changed) {
            item.controlledBySelectedDepartment = item.controlledBySelectedDepartmentInitial
          }
        })
        this.changedItems = []
        this.changedItemsIds = new Set()

        this.updateAllItemsChecked()

        if (notify) {
          this.$q.notify({
            type: 'warning',
            message: 'Изменения сброшены',
            progress: true,
            timeout: 3000
          })
        }
      }
    },
    onSaveChanges: function () {
      if (!this.hasEditAccess) {
        this.$q.notify({
          type: 'negative',
          message: 'Нет доступа на редактирование',
          progress: true,
          timeout: 4000
        })
        return
      }

      this.loading = true

      const bodyFormData = new FormData()
      bodyFormData.set('stockId', this.stockId)
      bodyFormData.set('depId', this.departmentSelectorConfig.departmentId)
      const toolsChanges = this.changedItems.map(item => {
        return { id: item.id, controlledBySelectedDepartment: item.controlledBySelectedDepartment }
      })
      bodyFormData.set('changes', JSON.stringify({ result: toolsChanges }))

      return axiosPost({
        url: 'service/delta/stock/control/edit',
        data: bodyFormData,
        config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } },
        onSuccess: (response) => {
          this.$q.notify({
            type: 'positive',
            message: 'Настройки контроля наличия успешно сохранены',
            progress: true,
            timeout: 3000
          })

          this.clearChanges(false)
          this.$refs.table.onUpdate()
        },
        onFailure: (response) => {
          this.$q.notify({
            type: 'negative',
            message: response.message || 'Ошибка сохранения настроек контроля наличия',
            progress: true,
            timeout: 10000
          })

          return Promise.reject(response.message)
        }
      }).finally(() => {
        this.loading = false
      })
    },

    onPerformControl: function () {
      showStockControlDialog({
        // stockControlRecordId: null,
        stockId: this.stockId,
        depId: this.departmentSelectorConfig.departmentId,
        formId: this.formId,
        readonly: false,
        onRecordSaved: null,
        mobile: false,
        target: this
      })
    },

    getTrClass: function (bodyPropsRow) {
      return bodyPropsRow.hasChanges ? ' bg-blue-1 ' : ''
    },

    getTdClass: function (col, row) {
      if (col.name === 'isParty' && row.isParty) {
        return 'bg-accent text-white cursor-pointer'
      }
    }
  }
}

